class Tabs extends HTMLElement {
  constructor() {
    super();

    var parent = this.closest('.section');
    var parentIndex = Array.from(parent.parentNode.children).indexOf(parent)
    var _this = this;

    document.addEventListener('scroll', function() {
      var activeElement = document.elementFromPoint(screen.width/2, screen.height/2);

      if (activeElement) {
        var currentSection = activeElement.closest('.section');

        if(currentSection && currentSection.closest('#MainContent')){
          var currentSectionIndex = Array.from(currentSection.parentNode.children).indexOf(currentSection);
          var difference = (currentSectionIndex - parentIndex) - 1;

          if(difference >= 0) {
            for (let index = 0; index < _this.children.length; index++) {
              const element = _this.children[index];
              element.classList.remove('active');
            }

            if (_this.children[difference]) {
              _this.children[difference].classList.add('active');
            }
          }
        }
      }
    })
  }
}

customElements.define("tab-highlights", Tabs);

class TabsClick extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', function() {
      const sectionId = this.getAttribute('href').replace('#','');
      
      if (!document.getElementById(sectionId)) return;

      const sectionTop = document.getElementById(sectionId).offsetTop;
      const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
      const scrollBarHeight = document.querySelector('.tabs').offsetHeight;

      window.scrollTo({
        top: (sectionTop - headerHeight - scrollBarHeight),
        left: 0,
        behavior: "smooth",
      });

    })
  }
}

customElements.define("tab-scroll", TabsClick);